import { render } from "./PasswordLost.vue?vue&type=template&id=a8edc160&scoped=true"
import script from "./PasswordLost.vue?vue&type=script&lang=js"
export * from "./PasswordLost.vue?vue&type=script&lang=js"

import "./PasswordLost.vue?vue&type=style&index=0&id=a8edc160&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8edc160"]])

export default __exports__